<!--公告及新闻稿-->
<template>
  <div>
    <div class="header_index_nav">
      <header>
        <div class="index_nav top">
          <div class="nav_box">
            <div class="nav_flex">
              <div class="nav_logo_w"></div>
              <div class="nav_li">
                <div class="nav_li_text">关于我们</div>
                <div class="nav_li_text">社会责任</div>
                <div class="nav_li_text">新闻动态</div>
                <div class="nav_li_text">投资者关系</div>
                <div class="nav_li_text">加入我们</div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <main class="index_main_content">
      <div class="index_main_body other">
        <div class="zcgy_img"><img src="../../assets/img/zcgy_nav.png"></div>
        <div class="zcgy_word">
          <div class="zcgy_ch">投资者关系</div>
          <div class="zcgy_en">Investor Relations</div>
        </div>
      </div>
      <!--二级导航-->
      <div class="second_nav">
        <div class="second_nav_list">
          <div>公告及新闻稿</div>
          <div>财务报告</div>
          <div>董事会</div>
          <div>电话会议</div>
          <div>分析师</div>
          <div>企业管治文件</div>
          <div>联系我们</div>
          <div>常见问题</div>
          <div>Investor Relations</div>
        </div>
      </div>
      <!--内容-->
      <div class="content_width_box">
        <div class="content_title">
          <div class="title_left_h2">公告及新闻稿</div>
          <div class="title_right_tab">
            <div class="tab1">公告</div>
            <div class="tab2">新闻稿</div>
          </div>
        </div>
        <div class="select_box">
          <multiselect 
          v-model="years"
        :options="[2021,2022,2023]" 
        :searchable="false" :close-on-select="true" :show-labels="false" placeholder="选择年份"></multiselect>
          <!-- <input placeholder="下拉框选年度"> -->
        </div>
        <div class="content_list_layout">
          <div class="list_box_layout">
            <div class="year_title">2022</div>
            <div class="list_box noborder">
              <i class="iconfont icon-website-PDF"></i>
              <div class="list_content">
                <div class="list_title">公告及通告 - 內幕消息/季度業績 - 截至二零二二年九月三十日止三個月</div>
                <div class="list_date">2022-10-23</div>
              </div>
            </div>
          </div>
          <div class="list_box_layout">
            <div class="year_title">2022</div>
            <div class="list_box noborder">
              <i class="iconfont icon-website-PDF"></i>
              <div class="list_content">
                <div class="list_title">公告及通告 - 內幕消息/季度業績 - 截至二零二二年九月三十日止三個月</div>
                <div class="list_date">2022-10-23</div>
              </div>
            </div>
          </div>
          <div class="list_box_layout">
            <div class="year_title">2022</div>
            <div class="list_box">
              <i class="iconfont icon-website-PDF"></i>
              <div class="list_content">
                <div class="list_title">公告及通告 - 內幕消息/季度業績 - 截至二零二二年九月三十日止三個月</div>
                <div class="list_date">2022-10-23</div>
              </div>
            </div>
          </div>
        </div>
        <div class="web_fenye_layout">
          <div class="web_fenye">
            <div class="fy_list">1</div>
            <div class="fy_list">2</div>
            <div class="fy_list">3</div>
            <div class="fy_list">4</div>
            <div class="fy_list"><i class="iconfont icon-website-xiangyoujiantou"></i></div>
          </div>
        </div>
      </div>


    </main>
    <footer class="index_footer">
      <div class="index_footer_layout">
        <div class="in_footer_top">
          <div class="footer_logo"><img src="../../assets/img/kslogo.png"></div>
          <div class="footer_nav">
            <div>关于我们</div>
            <div>社会责任</div>
            <div>新闻动态</div>
            <div>投资者关系</div>
            <div>加入我们</div>
          </div>
          <div class="footer_follow">
            <div class="follow_title">关注我们</div>
            <i class="iconfont icon-website-weixin"></i>
            <i class="iconfont icon-website-weibo"></i>
            <i class="iconfont icon-website-yutube"></i>
          </div>
        </div>
        <div class="in_footer_company">
          <div>金山办公</div>
          <div>西山居</div>
          <div>金山云</div>
          <div>金山世游</div>
        </div>
        <div class="in_footer_copyright">
          <span>京公网安备11010802025727（总）</span>      
          <span>网出证（京）字第168号</span>      
          <span>京网文【2014】0937-238号</span>      
          <span>京ICP备06025896-1号</span>
        </div>
      </div>
    </footer>
    
    
  </div>
</template>
<script>
export default {
  data(){
    return{
      years:''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_website.less';
    @import '../../assets/css/ks_website_m.less';
    @import '../../assets/fonts/iconfont.css';
</style>
